import { Page } from "@/models/page-models/Page";

export const InvoicePaymentReceiptView: Page = {
  "path": "invoice-payment-receipt/:receiptId",
  "name": "Receipt Voucher",
  "props": {
    "data": {
      "title": "Receipt Voucher",
      "printable": "TRUE",
      "url": "invoice-payment-receipt/:receiptId",
      "groups": [
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "custom_InvoicePaymentDetails",
                  "variable": "fetchedData.receiptDetails.data",
                  "label": "Invoice Payment Details",
                  "disabled": "FALSE",
                  "showIf": "{{fetchedData.receiptDetails.data}}",
                  "config": {
                    "customerDetailsVariable": "fetchedData.customerDetails.data"
                  }
                }
              ]
            },
            {
              "name": "2a",
              "pageItems": [
                {
                  "type": "table",
                  "label": "Payments",
                  "disabled": "FALSE",
                  "showIf": "{{fetchedData.receiptDetails.data}}",
                  "items": "fetchedData.receiptDetails.data.payments",
                  "headers": [
                    {
                      "value": "type",
                      "text": "Type"
                    },
                    {
                      "value": "value",
                      "text": "Value",
                      "formula": "fn(HELPER_FN,currency,{{__item.value}})"
                    },
                    {
                      "value": "invoice._id",
                      "text": "Invoice",
                      "showIf": "fn(LOGICAL,fn(CONCAT,',{{fetchedData.customerDetails.data.customerType}},'),!=,'Miscellaneous')",
                      "formula": "fn(CONDITIONAL,fn(LOGICAL,{{__item.proformaInvoice._id}},>,0),Proforma Invoice: {{__item.proformaInvoice._id}},{{__item.invoice._id}})"
                    },
                    {
                      "value": "miscInvoice._id",
                      "text": "Invoice",
                      "showIf": "fn(LOGICAL,fn(CONCAT,',{{fetchedData.customerDetails.data.customerType}},'),==,'Miscellaneous')"
                    }
                  ],
                  "printable": false,
                  "tableType": "static"
                }
              ]
            },
            {
              "name": "2b",
              "pageItems": [
                {
                  "type": "table",
                  "label": "Payments",
                  "disabled": "FALSE",
                  "showIf": "fn(LOGICAL,fn(MATCH_ROLE,Accounting | Manager),||,fn(MATCH_ROLE,Accounting | Executive))",
                  "items": "fetchedData.receiptDetails.data.payments",
                  "headers": [
                    {
                      "value": "type",
                      "text": "Type"
                    },
                    {
                      "value": "value",
                      "text": "Value",
                      "formula": "fn(HELPER_FN,currency,{{__item.value}})"
                    },
                    {
                      "value": "invoice._id",
                      "text": "Invoice",
                      "showIf": "fn(LOGICAL,fn(CONCAT,',{{fetchedData.customerDetails.data.customerType}},'),!=,'Miscellaneous')"
                    },
                    {
                      "value": "miscInvoice._id",
                      "text": "Invoice",
                      "showIf": "fn(LOGICAL,fn(CONCAT,',{{fetchedData.customerDetails.data.customerType}},'),==,'Miscellaneous')"
                    }
                  ],
                  "printable": true,
                  "tableType": "static"
                }
              ]
            },
            {
              "name": "3a",
              "pageItems": [
                {
                  "type": "fileupload",
                  "variable": "fetchedData.receiptDetails.data.uploadedProof",
                  "label": "Payment Proof",
                  "disabled": "TRUE",
                  "showIf": "{{fetchedData.receiptDetails.data.uploadedProof}}",
                  "previewType": "standard"
                }
              ]
            },
            {
              "name": "3",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Reject",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "rejectPayment",
                        "type": "fnSubmit",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v2/invoice-payment-receipt/{{fetchedData.receiptDetails.data._id}}/reject",
                        "arg2Key": "postData",
                        "arg2Value": "\"{}\"",
                        "arg3Key": "refreshPage",
                        "arg3Value": "TRUE"
                      },
                      "name": "rejectPayment"
                    }
                  ],
                  "disabled": "FALSE",
                  "showIf": "fn(LOGICAL,fn(CONCAT,',{{fetchedData.receiptDetails.data.status}},'),==,'Submitted')",
                  "color": "error"
                },
                {
                  "type": "button",
                  "label": "Approve",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "approvePayment",
                        "type": "fnSubmit",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v2/invoice-payment-receipt/{{fetchedData.receiptDetails.data._id}}/approve",
                        "arg2Key": "postData",
                        "arg2Value": "\"{}\"",
                        "arg3Key": "refreshPage",
                        "arg3Value": "TRUE"
                      },
                      "name": "approvePayment"
                    }
                  ],
                  "disabled": "fn(LOGICAL,fn(SUBTRACT,{{fetchedData.receiptDetails.data.expectedAmountReceived}},{{fetchedData.receiptDetails.data.amountReceived}}),>,0.00001)",
                  "showIf": "fn(LOGICAL,fn(CONCAT,',{{fetchedData.receiptDetails.data.status}},'),==,'Submitted')",
                  "color": "secondary"
                }
              ],
              "showIf": "fn(LOGICAL,fn(MATCH_ROLE,Accounting | Manager),||,fn(MATCH_ROLE,Accounting | Executive))"
            },
            {
              "name": "3",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Retract",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "retractPayment",
                        "type": "fnSubmit",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v1/invoice-payment-receipt/{{fetchedData.receiptDetails.data._id}}/retract",
                        "arg2Key": "postData",
                        "arg2Value": "\"{}\"",
                        "arg3Key": "refreshPage",
                        "arg3Value": "TRUE",
                        "arg4Key": "requestMethod",
                        "arg4Value": "DELETE"
                      },
                      "name": "retractPayment"
                    }
                  ],
                  "disabled": "fn(LOGICAL,{{__store.user._id}},!==,{{fetchedData.receiptDetails.data.createdBy._id}})",
                  "showIf": "fn(LOGICAL,fn(LOGICAL,fn(CONCAT,',{{fetchedData.receiptDetails.data.status}},'),==,'Submitted'),||,fn(LOGICAL,fn(CONCAT,',{{fetchedData.receiptDetails.data.status}},'),==,'Pending'))",
                  "color": "error"
                }
              ],
              "showIf": "fn(LOGICAL,fn(MATCH_ROLE,Accounting | Manager),||,fn(MATCH_ROLE,Accounting | Executive))"
            },
            {
              "name": "4",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Print",
                  "disabled": "FALSE",
                  "color": "primary",
                  "buttonType": "print"
                },
                {
                  "type": "button",
                  "label": "Validate Payment",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "validateIpr",
                        "type": "fnSubmit",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v1/invoice-payment-receipt/{{fetchedData.receiptDetails.data._id}}/submit",
                        "arg2Key": "postData",
                        "arg2Value": "{}",
                        "arg3Key": "refreshPage",
                        "arg3Value": "TRUE"
                      },
                      "name": "validateIpr"
                    }
                  ],
                  "disabled": "FALSE",
                  "showIf": "fn(LOGICAL,fn(NOT,fn(LOGICAL,fn(MATCH_ROLE,Accounting | Manager),||,fn(MATCH_ROLE,Accounting | Executive))),&&,fn(LOGICAL,fn(CONCAT,',{{fetchedData.receiptDetails.data.status}},'),==,'Pending'))",
                  "color": "secondary"
                }
              ]
            }
          ],
          "type": "genericGroup"
        }
      ],
      "useMaxPageWidth": true,
      "printDocDate": "{{fetchedData.receiptDetails.data.createdAt}}"
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getPaymentReceiptDetails",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v2/invoice-payment-receipt/{{__params.receiptId}}",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.receiptDetails"
        },
        "name": "getPaymentReceiptDetails"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "getCustomerDetails",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v2/customers/{{fetchedData.receiptDetails.data.customer._id}}",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.customerDetails"
        },
        "name": "getCustomerDetails"
      }
    ],
    "functions": []
  },
  "forRole": "ACCOUNTING_MANAGER,ACCOUNTING_EXECUTIVE,SALES_ACCOUNT_EXECUTIVE,SALES_MANAGER,GENERAL_MANAGER",
  "visible": false
}